import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ALARM_SUGGESTION_ACCEPTREJECT } from './url-constants';

type AlarmSuggAcceptRejectEndpointSpecification = ApiEndpointSpecification;
export const AlarmSuggAcceptRejectEndpointSpecification: AlarmSuggAcceptRejectEndpointSpecification = {
    url: ALARM_SUGGESTION_ACCEPTREJECT,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'AlarmSuggestionAcceptRejectRequestParams',
    requestBodySchemaName: 'AlarmSuggestionAcceptRejectRequestBody',
    okResponseSchemaName: 'AlarmSuggestionAcceptRejectOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 2   

};

export const invokeAlarmSuggAcceptReject = Helpers.makeApiRequestFn<  
    Types.AlarmSuggestionAcceptRejectRequestParams,
    Types.AlarmSuggestionAcceptRejectRequestBody,
    Types.AlarmSuggestionAcceptRejectOkResponse
>(AlarmSuggAcceptRejectEndpointSpecification);
